import { mainBlue, white } from "@u4i/styles/styles-variables"
import * as React from "react";
import { opacity7 } from "../../constants/Constants";
import { mapModuleStyling } from "../../constants/StaticMethods";

interface IPropTypes {
  cx: number
  cy: number
  isCompleted: boolean
  radius: number
  required: boolean
  title: string
  onModuleHover: (cx: number, cy: number, title: string, hoverIn: boolean) => void 
  showModuleInVE: () => void
}

export const OnlineDiscussionIcon = (props: IPropTypes) => {
  const {
    cx,
    cy,
    isCompleted,
    radius,
    required,
    title,
    onModuleHover,
    showModuleInVE
  } = props;

  const [opacity, setOpacity] = React.useState<boolean>(false);

  const handleOpacity = () => {
    opacity ? setOpacity(false) : setOpacity(true);
  }

  const moduleHover = (mouseEnter: boolean) => {
    onModuleHover(cx, cy, title, mouseEnter);
  }

  return (
    <svg>
      <g
        onClick={showModuleInVE}
        onMouseEnter={() => { handleOpacity(); moduleHover(true); }}
        onMouseLeave={() => { handleOpacity(); moduleHover(false); }}
        style={{ cursor: "pointer", ...(opacity && { opacity: opacity7 }) }}
      >
        <circle
          cx={cx}
          cy={cy}
          r={isCompleted ? radius : radius-3}
          style={mapModuleStyling(isCompleted)}
        >
        </circle>
        <g fill={isCompleted ? white : mainBlue}>
          <path
            d={`M${cx+12} ${cy-1}h-.316l-.913-2.438a4.363 4.363 0 001.685-5.92c-1.193-2.089-3.861-2.82-5.967-1.67-1.018.556-1.79 1.531-2.071 2.646l-3.265-.349c-.245-1.532-1.685-2.611-3.23-2.368a2.818 2.818 0 00-2.421 2.786c0 .488.14.975.386 1.428l-3.931 3.83a4.315 4.315 0 00-2.598-.87c-2.422 0-4.388 1.95-4.388 4.352 0 2.403 1.966 4.353 4.388 4.353l.878 5.223c-1.44.627-2.107 2.298-1.475 3.726a2.867 2.867 0 003.756 1.463c1.334-.557 2.001-2.02 1.615-3.413l3.089-1.602c2 2.194 5.44 2.368 7.687.383 1.124-1.01 1.79-2.472 1.79-3.97 0-.382-.035-.8-.14-1.183l3.405-1.741a2.86 2.86 0 004.037.244 2.806 2.806 0 00.245-4.005c-.666-.557-1.439-.905-2.246-.905zm0 1.044c.456 0 .807.349.807.801 0 .453-.35.801-.807.801a.791.791 0 01-.807-.8c0-.453.35-.802.807-.802zm-3.37-9.924c.667 0 1.229.557 1.229 1.219s-.562 1.219-1.229 1.219a1.239 1.239 0 01-1.228-1.219c0-.662.526-1.219 1.228-1.219zm-2.492 3.97c0-.174.105-.383.246-.488a3.738 3.738 0 011.193-.557 3.27 3.27 0 011.018-.14c.351 0 .702.07 1.018.14.421.105.842.314 1.193.592.14.105.246.314.246.488v.94h-4.914zm-7.828-4.179c.456 0 .807.349.807.801 0 .453-.35.801-.807.801a.791.791 0 01-.807-.8c0-.419.35-.802.807-.802zm-1.65 2.612c0-.14.07-.244.176-.313.245-.175.526-.28.807-.349.21-.07.456-.104.667-.104.21 0 .456.035.667.104.28.07.527.21.772.383.257.263.176.586.176.94h-3.23v-.661zm-7.371 5.258c.667 0 1.228.557 1.228 1.219 0 .661-.561 1.218-1.228 1.218a1.239 1.239 0 01-1.229-1.218c.035-.662.562-1.22 1.229-1.22zm-2.457 4.91v-.94c0-.175.105-.383.245-.488a3.738 3.738 0 011.194-.557 3.27 3.27 0 011.018-.14c.35 0 .702.07 1.018.14.421.104.842.313 1.193.592.14.104.246.313.246.487v.94zm6.072 11.352h-3.264v-.627c.107-.437.63-.568.983-.697.21-.07.456-.104.667-.104.21 0 .456.035.667.104.28.07.526.21.772.383.257.263.175.586.175.94zm-2.457-2.438c0-.453.351-.8.807-.8.457 0 .808.347.808.8 0 .453-.351.801-.808.801-.42.035-.772-.348-.807-.8zm2.808-.975a2.927 2.927 0 00-1.72-.8l-.877-5.224a4.35 4.35 0 002.106-1.497l3.264 1.706a5.221 5.221 0 00.281 4.283zm3.44-7.104l-3.23-1.67c.141-.454.212-.906.212-1.394 0-.905-.281-1.776-.808-2.507l3.932-3.795c1.334.8 3.089.417 3.896-.906.105-.174.176-.348.246-.522l3.264.348a4.335 4.335 0 001.72 3.204l-2.878 5.327c-2.282-.905-4.914-.104-6.354 1.915zm5.968 1.289c0 .836-.702 1.497-1.545 1.497-.842 0-1.51-.661-1.51-1.497 0-.836.668-1.497 1.51-1.497h.035c.843 0 1.51.661 1.51 1.497zm1.51 4.561h-6.074v-1.149c0-.243.106-.452.316-.592a5.817 5.817 0 011.475-.73 5.26 5.26 0 011.263-.175c.422 0 .843.07 1.264.174.527.14 1.053.383 1.474.731.176.14.316.383.316.592zm4.984-7.52c0 .208.035.417.105.626l-3.23 1.671c-.386-.766-.982-1.393-1.684-1.88l2.878-5.328c.456.174.948.244 1.44.244.28 0 .56-.035.842-.07l.912 2.438a2.508 2.508 0 00-1.263 2.298zm4.458 1.392h-3.265c-.045-.376-.007-.677.176-.94.245-.174.526-.314.807-.383.21-.07.456-.105.667-.105.21 0 .456.035.667.105.28.07.526.209.772.383.257.263.176.585.176.94z`}
            strokeWidth={0.7}
          />
        </g>
      </g>
    </svg>
  )
}
